/**
 * Original-to-production mapping for product-page artwork.
 * Full-page mockups are layout references only and are not shipped.
 * Hero exports may include transparency — place on white backgrounds.
 */
export const PRODUCT_ASSETS = {
  botTraderHero: {
    original: "BotTraderTop.png",
    src: "/images/products/bot-trader-hero.png",
    width: 1024,
    height: 560,
    alt: "Illustrative Bot Activity screen with an example paper signal, latency, and fill",
    priority: true,
  },
  botTraderTradeCard: {
    original: "Bot Trader Finished Image 2.png",
    src: "/images/products/bot-trader-trade-card.png",
    width: 1024,
    height: 665,
    alt: "Example paper trade card showing signal time, recorded latency, and fill details",
  },
  botTraderNotifications: {
    original: "Bot Trader Finished Image 3.png",
    src: "/images/products/bot-trader-notifications.png",
    width: 675,
    height: 801,
    alt: "Illustrative iPhone lock screen with paper fill alert notifications",
  },
  buildingStrategiesHero: {
    original: "BuildStrategiesTop.png",
    src: "/images/products/building-strategies-hero.png",
    width: 1024,
    height: 560,
    alt: "No-code strategy builder cards beside an example historical results phone",
    priority: true,
  },
  buildingStrategiesScoringLeft: {
    original: "StrategyBuilderIMagte1LeftSide.png",
    src: "/images/products/building-strategies-scoring-left.png",
    width: 765,
    height: 437,
    alt: "Illustrative Custom Score cards connecting saved strategies by weighted metrics",
  },
  buildingStrategiesScoringRight: {
    original: "StrategyBuilderFinishedImage1RightSide.png",
    src: "/images/products/building-strategies-scoring-right.png",
    width: 705,
    height: 729,
    alt: "Saved strategies list beside a Custom Score weight panel with example values",
  },
  strategyDiscoveryPhone: {
    original: "StrategyDiscoveryImage1.png",
    src: "/images/products/strategy-discovery-phone.jpg",
    width: 607,
    height: 1024,
    alt: "Strategy Discovery setup on iPhone, including sample split and Custom Score target",
    priority: true,
  },
  strategyDiscoveryReview: {
    original: "StrategyDiscoveryImage2.png",
    src: "/images/products/strategy-discovery-review.png",
    width: 1024,
    height: 597,
    alt: "Illustrative Discovery review with sample split, candidate list, and coverage settings",
  },
};

export const LAYOUT_REFERENCES = {
  botTraderHero: "Bot Trader Product.png",
  botTraderSequence: "Bot Trader Product Bottom.png",
  botTraderNotifications: "Bot Trader Product Image 3.png",
  buildingStrategiesHero: "Strategy Builder Product Top.png",
  buildingStrategiesScoring: "My Strategies Product bottom.png",
  strategyDiscoveryHero: "Strategy Discovery Image 1.png",
  strategyDiscoveryReview: "Strategy Discovery Image 2.png",
};
